import _ from "lodash";
import { DateTime } from "luxon";

import * as allUpdates from "./entries";

export const updates = _.sortBy(Object.values(allUpdates), (u) => u.date).reverse();

export const latestUpdateDate = DateTime.fromISO(updates[0].date).toLocaleString(
  DateTime.DATE_FULL
);

export const latestUpdateId = updates[0].id;
